/* eslint-disable react/no-this-in-sfc */
import getYear from "date-fns/getYear";
import parseISO from "date-fns/parseISO";
import type { IQuotesHistoryQuery } from "lib/graphql/queries/__generated__/QuotesHistoryQuery.generated";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";

export default function calculateMarketReturns(quotes: IQuotesHistoryQuery["quotesHistory"]) {
  return quotes
    .map((history) => {
      const prices = history.nodes;
      if (prices.length < 2) {
        return null;
      }
      const [firstPoint, lastPoint] = [history.nodes[0], history.nodes[prices.length - 1]];
      const firstPrice = firstPoint.close;
      const lastPrice = lastPoint.close;

      const totalReturn = lastPrice / firstPrice - 1;
      const years = getYear(parseISO(lastPoint.date)) - getYear(parseISO(firstPoint.date));
      const annualReturn = years >= 2 ? (1 + totalReturn) ** (1 / years) - 1 : null;

      return {
        tickerSymbol: history.tickerSymbol,
        firstPoint,
        lastPoint,
        totalReturn: lastPrice / firstPrice - 1,
        annualReturn,
      };
    })
    .filter(notUndefinedOrNull);
}
